module.exports = __webpack_public_path__ + "img/fastplus-master.1efb079b.png";